/**
 * Per-agent swatch colours for Atlas Command & Chat.
 *
 * These are *identity* colours — each specialist agent gets a distinct hue
 * so users can tell them apart at a glance (avatar, thread history grouping,
 * timeline markers in multi-agent handoffs). Source of truth is the design
 * bundle at atlas-chat/shared.jsx::AGENTS.
 *
 * Keeping them in @ezhire/tokens (rather than inline in the chat feature)
 * honours the "no hex outside packages/tokens" invariant (atlas-plan §10.1).
 */

export const agentSwatch = {
  'agent-paid-search-manager': '#286B94', // Mason — approved AI Teams blue
  'agent-paid-social-manager': '#9A4F70', // Chloe — approved AI Teams rose
  'agent-sales-manager': '#986023', // Marcus — approved AI Teams amber
  atlas:     '#66ADD1', // Atlas accent-400 — the router
  finance:   '#6E8BC0', // cool blue, distinct from the router
  ops:       '#3DB47C', // success green, slightly muted
  sales:     '#E89A4E', // warm orange
  marketing: '#C5739C', // magenta/rose
  hubspot:   '#FF7A59', // HubSpot's own brand orange (vendor identity)
} as const;

export type AgentSwatchKey = keyof typeof agentSwatch;

/** Workforce identities for Slack. White text clears AA on every swatch.
 * Avatar gradients only darken these stops, preserving that contrast floor.
 * Distinct muted hues extend Atlas blue/teal and the existing identity palette.
 */
export const workforceAgentSwatch = {
  'sales-engineer': '#986023', // Lucas — ochre
  'database-architect': '#286B94', // Priya — Atlas blue
  'ai-agents-engineer': '#376C64', // Jordan — eucalyptus
  'support-engineer': '#34734A', // Usman — forest
  'marketing-engineer': '#9A4F70', // Daniel — rose
  cto: '#475570', // Stephen — slate
  'ai-agent-optimizer': '#796128', // Nora — olive gold
  'ai-engineer': '#286E7B', // Ethan — petrol
  'design-engineer': '#776080', // Mia — muted plum
  'mobile-engineer': '#A05240', // Ryan — terracotta
  librarian: '#666A3A', // Mira — moss
} as const;
